import type { JSX } from 'preact';
import { useEffect, useState } from 'preact/hooks';

type GwModule = typeof import('../gw/ui/GwRoot');
let cached: GwModule | null = null;

/** True for the Ground War mode id. Takes a plain string so it stays valid whether or not `GameMode` lists 'groundwar' yet. */
export function isGroundWarMode(mode: string): boolean {
  return mode === 'groundwar';
}

/**
 * Loads the Ground War chunk (gw/ui/GwRoot and everything under it) on first use and renders one of its exports.
 * The main bundle never imports the chunk statically, so artillery players do not download it.
 */
export function GwLazy({ pick, ...props }: { pick: keyof GwModule } & Record<string, unknown>) {
  const [mod, setMod] = useState<GwModule | null>(cached);
  useEffect(() => {
    if (!mod) {
      void import('../gw/ui/GwRoot').then((m) => {
        cached = m;
        setMod(m);
      });
    }
  }, []);
  if (!mod) {
    return (
      <div class="loading">
        <p class="muted">Digging the trenches…</p>
      </div>
    );
  }
  const C = mod[pick] as unknown as (p: Record<string, unknown>) => JSX.Element;
  return <C {...props} />;
}
